import queryString from 'query-string';
import { LocaleCode, MarketCode } from '@tink/config/src/markets';
import { normalizeLocale } from '@tink/core/src/utils';
import { PISCapability } from '@tink/core/src/services/ProviderGroupsService/types';
import { ajaxRetry } from '../lib-api/ajaxRetry';
import { base, createApiURL, ResponseObj } from '../lib-api/services/base';
import { ProvidersApiResponse } from '../models/provider';
import { ProviderCapability } from '../models/providerCapability';

type ProviderQueryParams = {
  capability?: ProviderCapability;
  capabilities?: ProviderCapability;
  pisCapability?: PISCapability;
};
type ProviderListPayload = {
  market: MarketCode;
  locale: LocaleCode;
  request?: typeof ajaxRetry;
  queryParams?: ProviderQueryParams;
};

export type ProviderPayload = {
  locale: LocaleCode;
  providerName: string;
};

export type ProvidersClient = {
  list: (payload: ProviderListPayload) => Promise<ResponseObj<ProvidersApiResponse>>;
  get: (payload: ProviderPayload) => Promise<ResponseObj<ProvidersApiResponse>>;
};

/** istanbul ignore next: this is a client see ADR.
 * @module adrs/001-clients-services.md
 * */
export const providersClient: ProvidersClient = {
  async list({ market, locale, request = ajaxRetry, queryParams = {} }) {
    const headers = base.headers();

    headers['Accept-Language'] = normalizeLocale(locale);

    return request({
      headers,
      method: 'GET',
      url: createApiURL(
        `/api/v1/providers/${market}?${queryString.stringify({
          includeTestProviders: 'true',
          ...queryParams,
        })}`
      ),
    });
  },

  async get({ providerName, locale }) {
    const headers = base.headers();

    headers['Accept-Language'] = normalizeLocale(locale);

    return ajaxRetry({
      headers,
      method: 'GET',
      url: createApiURL(`/api/v1/providers?name=${providerName}`),
    });
  },
};
